import axios from "axios";
import { environment } from "../environment/environment";


const gatewayService = {
    async postApiGateway(requestBody) {

        const key = "1T5_V1D4$#T0k3n";
        const now = new Date();
        const token = this.getToken({ key, text: '' + now.getTime() });
        let result = await axios.post(`${environment.apiGatewayUrl}`, requestBody, {headers:{Authorization: 'Bearer ' + token}});

        return result;
    },


    getChangesCustomerDataEn (prevPositionJson, client, oldClientData){
        try {
            const replace = {};

            const variables = [
                'phone',
                'lastName',
                'secondLastName',
                'name',
                'email',
                'gender',
                'dob',
                'fullName'
            ];

            for (const itemVariable of variables) {
                if (client[itemVariable] !== oldClientData[itemVariable]) {
                    replace[`${prevPositionJson}${itemVariable}`] = client[itemVariable];
                }
            }
            return replace;
        } catch (error) {
            console.error('Error', error);
        }
    },

    getChangesCustomerData (prevPositionJson, client, oldClientData){
        try {
            const replace = {};

            const variables = [
                'numeroTelefono',
                'apellidoPaterno',
                'apellidoMaterno',
                'nombre',
                'email',
                'sexo',
                'fechaNacimiento',
                'nombreCompleto'
            ];

            for (const itemVariable of variables) {
                if (client[itemVariable] !== oldClientData[itemVariable]) {
                    replace[`${prevPositionJson}${itemVariable}`] = client[itemVariable];
                }
            }
            return replace;
        } catch (error) {
            console.error('Error', error);
        }
    },

    getToken(object) {
        const { key, text } = object;
        var keyBytes = [];
        var textBytes = [];
        for (var i = 0; i < key.length; i++) {
            keyBytes.push(key.charCodeAt(i));
        }
        for (var i = 0; i < text.length; i++) {
            textBytes.push(text.charCodeAt(i));
        }
        var s = [];
        for (var i = 0; i < 256; i++) {
            s[i] = i;
        }
        var j = 0;
        for (var i = 0; i < 256; i++) {
            j = (j + s[i] + keyBytes[i % keyBytes.length]) % 256;
            var tmp = s[i];
            s[i] = s[j];
            s[j] = tmp;
        }
        var i = 0;
        var j = 0;
        var cipherBytes = [];
        for (var k = 0; k < textBytes.length; k++) {
            i = (i + 1) % 256;
            j = (j + s[i]) % 256;
            var tmp = s[i];
            s[i] = s[j];
            s[j] = tmp;
            var t = (s[i] + s[j]) % 256;
            var cipherByte = textBytes[k] ^ s[t];
            cipherBytes.push(cipherByte);
        }
        var cipherText = btoa(String.fromCharCode.apply(null, cipherBytes));
        return cipherText;
    },
}

export default gatewayService;